import { normalizeGet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getClipboard = normalizeGet(function (args) {
  return tt.getClipboardData(args);
}, CONTAINER_NAME.BYTE);
export default getClipboard;